{
  "otherOrganizations": "다른 조직",
  "solutionIframe": "주요 컨텐츠",
  "unloadPromptMessage": "계속하시겠습니까?"
}
